import { useEffect, useState } from "react";
import "./item.less";
import { useSearchParams } from "react-router-dom";
import { formatTimeAsMinutesAndSeconds } from "@/utils";
import { Circle, ConfigProvider } from "react-vant";
import { ClockO, Replay } from "@react-vant/icons";
import { observer } from "mobx-react";
import uploadStore from "@/store/upload";
import { getScriptDetail, updateScript } from "@/server";

interface UUploadItemWraperProps {
  showName: boolean;
  imgSize?: string;
  style?: React.CSSProperties;
  item: any;
  index: number;
  params?: Record<string, any>;
  onItemSuccess?: (res: any) => void;
  onItemClick?: (item: any) => void;
}

const UploadItemWraper = (props: UUploadItemWraperProps) => {
  const {
    imgSize,
    style,
    showName = true,
    item,
    params,
    onItemSuccess,
  } = props;
  const handlePreview = (item) => {
    props.onItemClick?.(item);
  };
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // const scriptId = searchParams.get("script_id");
    // const sceneIndex = +searchParams.get("scene_index");
    // console.log("script_id", scriptId, "sceneIndex", sceneIndex);
    // if (scriptId === undefined || sceneIndex === undefined) return;

    if (item.status === "success") {
      console.log("item success", item);
      onItemSuccess?.(item);
      // getScriptDetail(scriptId).then((res) => {
      //   console.log("script detail", JSON.parse(res.item.content));
      //   let scenes = JSON.parse(res.item.content);
      //   scenes = scenes.map((scene, index) => {
      //     return index === sceneIndex
      //       ? {
      //           ...scene,
      //           materials: [...(scene.materials || []), item.result],
      //         }
      //       : scene;
      //   });

      //   console.log("scenes", scenes);

      //   updateScript(scriptId, {
      //     ...res.item,
      //     content: JSON.stringify(scenes),
      //     title: "",
      //   });
      // });
    }
  }, [item.status]);

  return (
    <div
      className="grid-item"
      style={{
        // width: imgSize,
        borderRadius: "12rpx",
      }}
    >
      <div
        className="img"
        style={{
          width: imgSize,
          height: imgSize,
          objectFit: "contain",
        }}
      >
        {item?.cover ? (
          <img
            src={item.cover}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            onClick={() => handlePreview(item)}
          />
        ) : null}

        {/* {item.progress} ==== {item.status} */}
        {item.file?.type.startsWith("video") && !!item.duration && (
          <div className="duration">
            {formatTimeAsMinutesAndSeconds(item.duration)}
          </div>
        )}
        {/* {getStatus()}============ {getProgress()} */}
        {item.status !== "success" && (
          <div className="progress">
            <div className="progress-inner">
              {item.status === "pending" && (
                <div className="pending">
                  <ClockO fontSize={24} />
                </div>
              )}
              {item.status === "uploading" && (
                <ConfigProvider
                  themeVars={{
                    circleTextFontSize: "12px",
                    circleTextColor: "#fff",
                  }}
                >
                  <Circle
                    rate={+item.progress}
                    speed={100}
                    size={46}
                    strokeWidth={70}
                    text={Math.floor(+item.progress) + "%"}
                  />
                </ConfigProvider>
              )}

              {item.status === "checking" && (
                <div className="cloud">
                  <span>
                    <i color="#fff" className="iconfont icon-upload" />
                  </span>
                  <div style={{ color: "#f5f5f5", fontSize: 10 }}>
                    云端解析中
                  </div>
                </div>
              )}

              {/* {getStatus() === "success" && (
                <div className="success">
                  <i color="#fff" className="iconfont icon-icon_success" />
                </div>
              )} */}

              {item.status === "failed" && (
                <div
                  className="error"
                  onClick={() => uploadStore.start(item.id)}
                >
                  <Replay fontSize={24} />
                  <div style={{ marginTop: 6 }}>上传失败</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {showName && <div className="name">{item.file?.name}</div>}
    </div>
  );
};

export default observer(UploadItemWraper);
